<template>
  <v-app :style="{background: $vuetify.theme.themes.light.background}">
    <v-main>
      <Navbar
        :hasDrawer="true"
        title="Services Syclus"
        v-if="usuario"
      />
      <Snackbar />
      <!-- App update snackbar -->
      <v-snackbar
        v-model="snackWithButtons"
        :timeout="timeout"
        bottom
        class="snack"
      >
        {{ snackWithBtnText }}
        <!-- <v-spacer /> -->
        <v-btn
          dark
          text
          color="#00f500"
          @click.native="refreshApp"
        >
          {{ snackBtnText }}
        </v-btn>
        <v-btn
          small
          icon
          @click="snackWithButtons = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-snackbar>
      <transition mode="out-in">
        <router-view></router-view>
      </transition>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Navbar from '@/components/shared/Navbar';
import Snackbar from '@/components/shared/Snackbar';

export default {
  name: 'App',
  components: {
    Navbar,
    Snackbar
  },
  data: () => ({
    refreshing: false,
    registration: null,
    snackBtnText: '',
    snackWithBtnText: '',
    snackWithButtons: false,
    timeout: -1
  }),
  computed: {
    ...mapGetters(['usuario', 'usuario_licenca'])
  },
  methods: {
    ...mapMutations(['LOGIN_FAILURE', 'REMOVE_USUARIO_TOKEN']),
    showRefreshUI(e) {
      this.registration = e.detail;
      this.snackBtnText = 'Atualizar';
      this.snackWithBtnText = 'Nova versão disponível!';
      this.snackWithButtons = true;
    },
    refreshApp() {
      this.snackWithButtons = false;

      if (!this.registration || !this.registration.waiting) return;
      
      this.registration.waiting.postMessage('skipWaiting');
    },
    syncLogout(event) {
      // Acessar event.newValue que é o id_licenca da empresa que está fazendo logout
      // filtrar a licença no array de tokens e remover o objeto
      // atualizar a pagina para resetar o estado
      if (event.key === 'logout' && event.newValue === (this.usuario_licenca && this.usuario_licenca.id_licenca)) {
        this.$router.go();
      } else if (event.key === 'logout' && !!event.newValue) {
        const id_licenca = event.newValue;
        this.REMOVE_USUARIO_TOKEN(id_licenca);
        // TODO: Tem algo errado com o refresh login, quando em mais de uma licença
        // Está enviando o refresh_token invalido
      }
    }
  },
  created() {
    document.addEventListener(
      'swUpdated', this.showRefreshUI, { once: true }
    );

    window.addEventListener('storage', this.syncLogout);

    navigator.serviceWorker.addEventListener(
      'controllerchange', () => {
        if (!localStorage.getItem('hasPreviousSW')) {
          localStorage.setItem('hasPreviousSW', 'true');
          return;
        }
        
        if (this.refreshing) return;
        this.refreshing = true;
        window.location.reload();
      }
    );
  }
};
</script>

<style>
:root {
  --color-primary: #1976d2;
}
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
/* Track */
::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.15);
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.v-enter-active, .v-leave-active {
  transition: opacity .2s;
}
.v-enter, .v-leave-to /* .v-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.cursor-pointer {
  cursor: pointer;
}
</style>